import { Routes, Route } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import Home from "./Home/Home";
import Recipes from "./Recipes/Recipes";
import RecipeDetails from "./Recipedetails/RecipeDetails";
import About from "./About/About";
import Contact from "./Contact/Contact";
import Footer from "./Footer/Footer";

function Router() {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/view-recipes" element={<Recipes />} />
        <Route path="/RecipeDetails/:recipe_id" element={<RecipeDetails/>} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer />
    </>
  );
}

export default Router;